import React from 'react'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'
import Register from '../components/register/register'
import Recruiters from '../components/placement/recruiters'
import AllSubjects from '../components/common/allSubjects'

const RegisterPage = () => {
    return (
        <>
            <Navbar />
            <div className=''>
                <Register />
                <AllSubjects />
                <Recruiters />
            </div>
            <Footer />
        </>
    )
}
export default RegisterPage;